import React, { useEffect, useRef } from 'react';
import { FcGoogle } from 'react-icons/fc';
import './GoogleSignIn.css';

const GoogleSignIn = ({ onSuccess, onError, buttonText = 'Continuar con Google' }) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    // Load Google Sign-In script
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
      console.log('🔍 Google Client ID:', clientId);
      console.log('🔍 Client ID length:', clientId?.length);
      console.log('🔍 All env vars:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP')));
      
      if (!clientId) {
        console.error('❌ REACT_APP_GOOGLE_CLIENT_ID is undefined!');
        console.error('Make sure you:');
        console.error('1. Have .env file in root directory');
        console.error('2. Restarted the development server (npm start)');
        console.error('3. Variable name is exactly: REACT_APP_GOOGLE_CLIENT_ID');
        return;
      }
      
      if (window.google && buttonRef.current) {
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: handleCredentialResponse,
          auto_select: false,
          cancel_on_tap_outside: true
        });

        // Render the button
        window.google.accounts.id.renderButton(
          buttonRef.current,
          {
            theme: 'outline',
            size: 'large',
            width: buttonRef.current.offsetWidth,
            text: 'continue_with',
            shape: 'rectangular',
            logo_alignment: 'left'
          }
        );
      }
    };

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const handleCredentialResponse = async (response) => {
    try {
      if (onSuccess) {
        await onSuccess(response.credential);
      }
    } catch (error) {
      console.error('Google Sign-In error:', error);
      if (onError) {
        onError(error);
      }
    }
  };

  return (
    <div ref={buttonRef} className="google-signin-button-container"></div>
  );
};

export default GoogleSignIn;
